// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoomSliderTimeline {
    appearance: none;
    height: var(--timeline-bottom-height);
    width: 97%;
  }
  
 .zoomSliderTimeline:focus {
    outline: none;
  }

  .zoomSliderTimeline::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  
  .zoomSliderTimeline:disabled::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }


  .zoomSliderTimeline:focus::-webkit-slider-runnable-track {
    background: var(--default-icon-color);
  }
  
  .zoomSliderTimeline::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  

  .zoomSliderTimeline:disabled::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }
  
  .zoomSliderTimeline:disabled::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: var(--default-disable-icon-color);
    border-radius: 1.3px;
    border: 0.2px solid #010101;
  }

  .zoomSliderTimeline::-ms-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  
  .zoomSliderTimeline::-ms-fill-lower {
    background: var(--default-icon-color);
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }

  .zoomSliderTimeline::-ms-fill-upper {
    background: var(--default-icon-color);
    border: 0.2px solid #010101;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  
  .zoomSliderTimeline::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
  }

  .zoomSliderTimeline::-moz-range-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
  }
  
  .zoomSliderTimeline::-webkit-slider-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-icon-color);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: calc(var(--timeline-bottom-height)/(-3));
    
  }


  .zoomSliderTimeline:disabled::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    border: 1px solid #000000;
    height: calc(var(--timeline-bottom-height)/1.5);
    width: 8px;
    border-radius: 3px;
    background: var(--default-disable-icon-color);
    cursor: pointer;
  }

`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/timeline/zoom/zoom.css"],"names":[],"mappings":"AAAA;IAEI,gBAAgB;IAChB,qCAAqC;IACrC,UAAU;EACZ;;CAED;IACG,aAAa;EACf;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;EAC7B;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;;IAEf,oDAAoD;IACpD,6CAA6C;IAC7C,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;;EAEA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,wBAAwB;IACxB,oDAAoD;;EAEtD;;;EAGA;IACE,oDAAoD;IACpD,yBAAyB;IACzB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;EACjB","sourcesContent":[".zoomSliderTimeline {\n    -webkit-appearance: none;\n    appearance: none;\n    height: var(--timeline-bottom-height);\n    width: 97%;\n  }\n  \n .zoomSliderTimeline:focus {\n    outline: none;\n  }\n\n  .zoomSliderTimeline::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n  .zoomSliderTimeline:disabled::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n\n\n  .zoomSliderTimeline:focus::-webkit-slider-runnable-track {\n    background: var(--default-icon-color);\n  }\n  \n  .zoomSliderTimeline::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n\n  .zoomSliderTimeline:disabled::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n  \n  .zoomSliderTimeline:disabled::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    \n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    background: var(--default-disable-icon-color);\n    border-radius: 1.3px;\n    border: 0.2px solid #010101;\n  }\n\n  .zoomSliderTimeline::-ms-track {\n    width: 100%;\n    height: 4px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    border-width: 16px 0;\n    color: transparent;\n  }\n  \n  .zoomSliderTimeline::-ms-fill-lower {\n    background: var(--default-icon-color);\n    border: 0.2px solid #010101;\n    border-radius: 2.6px;\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  }\n\n  .zoomSliderTimeline::-ms-fill-upper {\n    background: var(--default-icon-color);\n    border: 0.2px solid #010101;\n    border-radius: 2.6px;\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n  }\n  \n  .zoomSliderTimeline::-ms-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n  }\n\n  .zoomSliderTimeline::-moz-range-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n  }\n  \n  .zoomSliderTimeline::-webkit-slider-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-icon-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: calc(var(--timeline-bottom-height)/(-3));\n    \n  }\n\n\n  .zoomSliderTimeline:disabled::-ms-thumb {\n    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;\n    border: 1px solid #000000;\n    height: calc(var(--timeline-bottom-height)/1.5);\n    width: 8px;\n    border-radius: 3px;\n    background: var(--default-disable-icon-color);\n    cursor: pointer;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
